"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MailingListSubscriberCount = exports.Text = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var Text = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "et65oi80"
} : {
  target: "et65oi80",
  label: "Text"
})(_styles.text.regular, ";white-space:nowrap;color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.5)' : _styles.color.dark;
}, ";");
exports.Text = Text;

var MailingListSubscriberCount = function MailingListSubscriberCount(_ref) {
  var inverse = _ref.inverse,
      count = _ref.count;
  return /*#__PURE__*/_react["default"].createElement(Text, {
    inverse: inverse
  }, numberWithCommas(count), " developers and counting");
};

exports.MailingListSubscriberCount = MailingListSubscriberCount;

function numberWithCommas(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}